/*
 * \file client.js
 * \brief Main entry for the NGIC web system...
 *
 * Jimm Pratt & Danny Orndrup & Thomas Rosefalk
 * Copyright (C) CRYSBERG A/S 2017, 2018, 2019
 */

// Dependencies
import Vue from 'vue'
import Router from 'vue-router'

// Pages
const Home = () => import('@/components/pages/Home')
const Login = () => import('@/components/pages/Login')
const DeviceList = () => import('@/components/pages/DeviceList')
const Programs = () => import('@/components/pages/Programs')
const Sensors = () => import('@/components/pages/Sensors')
const Weather = () => import('@/components/pages/Weather')
const History = () => import('@/components/pages/History')
const Stations = () => import('@/components/pages/Stations')
const Survey = () => import('@/components/pages/Survey')
const Maps = () => import('@/components/pages/Maps')
const JSControl = () => import('@/components/JSControl')
const Admin = () => import('@/components/Admin')

Vue.use(Router)

let router = new Router({
  routes:
  [
    {
      path: '/',
      component: Login,
      name: 'login',
      meta: {
        title: 'Login'
      }
    },
    {
      path: '/admin',
      component: Admin,
      name: 'admin',
      meta: {
        title: 'Admin'
      }
    },    
    {
      path: '/home',
      component: Home,
      name: 'home',
      meta: {
        title: 'home'
      }
    },
    {
      path: '/devicelist',
      component: DeviceList,
      name: 'devicelist',
      meta: {
        title: 'Device List'
      }
    },
    {
      path: '/JSControl',
      component: JSControl,
      name: 'JSControl',
      meta: {
        title: 'JSControl'
      }
    },
    {
      path: '/stations/:StationId?',
      name: 'stations',
      component: Stations,
      meta: {
        title: 'Station & Sensors'
      }
    },
    {
      path: '/survey',
      component: Survey,
      name: 'survey',
      meta: {
        title: 'Survey'
      }
    },
    {
      path: '/sensors',
      component: Sensors,
      name: 'sensors',
      meta: {
        title: 'Sensors'
      }
    },
    {
      path: '/history',
      component: History,
      name: 'history',
      meta: {
        title: 'History'
      }
    },
    {
      path: '/weather',
      component: Weather,
      name: 'weather',
      meta: {
        title: 'Weather'
      }
    },
    {
      path: '/maps',
      component: Maps,
      name: 'maps',
      meta: {
        title: 'Maps'
      }
    },
    {
      path: '/programs',
      component: Programs,
      name: 'programs',
      meta: {
        title: 'Programs'
      }
    },
    {
      name: '404',
      path: '*', redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (router.app.LoggedIn !== true && to.path !== '/') { // Not logged in, trying to access other page than login
    router.push('/').catch(() => {})
  } else { // Logged in, no prevention
    if(next) next()
  }
})

export {
  router
}
